
import './aos';
import './background-images';
import './fade-page';
import './flickity';
import mrFormEmail from './form-email';
import mrIsotope from './isotope';
import mrOverlayNav from './overlay-nav';
import './navigation';
import './popovers';
import mrReadingPosition from './reading-position';
import mrSmoothScroll from './smooth-scroll';
import mrSticky from './sticky';
import './svg-injector';
import mrUtil from './util';

(() => {
  if (typeof $ === 'undefined') {
    throw new TypeError('Medium Rare JavaScript requires jQuery. jQuery must be included before theme.js.');
  }
})();

export {
  mrFormEmail,
  mrIsotope,
  mrOverlayNav,
  mrReadingPosition,
  mrSmoothScroll,
  mrSticky,
  mrUtil,
};
